import { render, staticRenderFns } from "./DeveloperPage.vue?vue&type=template&id=97bbd99a&scoped=true&"
import script from "./DeveloperPage.vue?vue&type=script&lang=js&"
export * from "./DeveloperPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbd99a",
  null
  
)

export default component.exports